"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _Formio = _interopRequireDefault(require("../Formio"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CKEDITOR = 'https://cdn.staticaly.com/gh/formio/ckeditor5-build-classic/master/build/ckeditor.js';
var LOCAL_CKEDITOR = "/libs/ckeditor.js";
var editorCache;

var WithCKEditor = function WithCKEditor(_WithCKEditor2) {
  return (
    /*#__PURE__*/
    function (_WithCKEditor) {
      _inherits(_class, _WithCKEditor);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "addCKE",
        // Копипаст с BaseComponent.addCKE
        value: function addCKE(element, settings, onChange) {
          // Различие только в след строчке. CKEditor падает когда settings = null
          // original: settings = _.isEmpty(settings) ? null : settings;
          settings = _lodash.default.isEmpty(settings) ? {} : settings;
          var libraryContainer; // Кэшируем ckeditor, т.к происходит много запросов на один и тот же ресурс

          if (editorCache) {
            libraryContainer = editorCache;
          } else {
            editorCache = fetch(LOCAL_CKEDITOR).then(function (response) {
              return response.text();
            }).then(function (fetchedSrcCode) {
              if (fetchedSrcCode.includes('ckeditor')) {
                return LOCAL_CKEDITOR;
              } else {
                // Если файла по адресу LOCAL_CKEDITOR не существует локально, то приходит ответ
                // со статусом 200, но содержит index.html -> не используем локальный ckedtior
                throw Error('Response to request for local CKEditor does not contain CKEditor source code');
              }
            }).catch(function (error) {
              console.error(error);
              return CKEDITOR;
            }).then(function (src) {
              return _Formio.default.requireLibrary('ckeditor', 'ClassicEditor', src, true);
            });
            libraryContainer = editorCache;
          }

          return libraryContainer.then(function () {
            if (!element.parentNode) {
              return Promise.reject();
            }

            return ClassicEditor.create(element, settings).then(function (editor) {
              editor.model.document.on('change', function () {
                return onChange(editor.data.get());
              });
              return editor;
            });
          });
        }
      }]);

      return _class;
    }(_WithCKEditor2)
  );
};

var _default = WithCKEditor;
exports.default = _default;